import React from 'react';
import './Projects.css';
import ProjectCards from './projectcards';
import Footer from './Footer'
import video1 from '../jpegs/Recording 2026-08-17 001526.mp4'
import video2 from '../jpegs/WhatsApp Video 2026-08-12 at 9.47.46 PM.mp4'
import video3 from '../jpegs/Recording 2026-08-17 012817.mp4'

// const projects = [
//   {
//     number: '01',
//     title: 'Mouse Counter',
//     description:
//       'An IoT-based mouse counting system that sends sensor data from an STM32 through ESP8266 to a web application and stores the data in MongoDB.',
//     tags: ['STM32', 'ESP8266', 'React', 'Node.js', 'MongoDB'],
//     type: 'IoT / Full Stack',
//     link: '#',
//   },
//   {
//     number: '02',
//     title: 'Personal Portfolio',
//     description:
//       'A modern responsive portfolio website built with React, featuring animated sections, project showcases and a clean dark interface.',
//     tags: ['React', 'JavaScript', 'CSS', 'Responsive UI'],
//     type: 'Frontend',
//     link: '#',
//   },
//   {
//     number: '03',
//     title: 'STM32 Embedded System',
//     description:
//       'A microcontroller-based system using ADC, PWM, UART and timers to collect, process and communicate sensor data.',
//     tags: ['STM32', 'C', 'ADC', 'PWM', 'UART'],
//     type: 'Embedded Systems',
//     link: '#',
//   },
// ];

const Projects = () => {
  return (
    <main className="projects-page">

      {/* Hero */}
      <section className="projects-hero">
        <div className="section-label">
          <span></span>
          SELECTED WORK
        </div>

        <h1>
          Things I've
          <br />
          <span>built.</span>
        </h1>

        <p>
          A collection of projects I've worked on across web development,
          embedded systems and IoT.
        </p>
      </section>

      {/* Projects */}
      <section className="projects-grid">
        <ProjectCards
  thumbLabel="PROJECT_01.PREVIEW"
  video={video1}
  title="Mouse Counter Website Dashboard"
  desc="A simple tool that tracks mouse clicks in real time."
  tags={['HTML', 'CSS', 'JavaScript','Expressjs','MongoDb']}
  link="https://forestgreen-mole-818716.hostingersite.com/"
/>
          <ProjectCards
            thumbLabel="PROJECT_01.PREVIEW"
            video={video2}
            title="IoT Device"
            desc="A simple tool that tracks mouse clicks in real time."
            tags={['HTML', 'CSS', 'JavaScript','Expressjs','MongoDb','esp8266,STM32']}
            link="https://forestgreen-mole-818716.hostingersite.com/"
          />
          <ProjectCards
            thumbLabel="PROJECT_01.PREVIEW"
            video={video3}
            title="My Portfolio"
            desc="A simple tool that tracks mouse clicks in real time."
            tags={['HTML', 'CSS', 'JavaScript']}
            link="https://forestgreen-mole-818716.hostingersite.com/"
          />
      </section>
 <Footer/>
    </main>
  );
};

export default Projects;